import moment, { Moment } from 'moment';
import React from 'react';
import GridFilter from '../../../../Base/Components/GridFilter/GridFilter';
import GridFilterItem from '../../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../../Base/Enums/GridFilterItemType.enum';
import { SelectValue } from '../../../../../Components/Base/Select/Select';
import { useAppContext } from '../../../../../Services/AppContext';
import { GRID_FILTER_KEYS } from '../../../../Base/Components/GridFilter/gridFilterKeys';
import useFilters from '../../../../Base/Hooks/useFilters';

export interface NurseCasesFilterFilterValues {
	createdAt?: Moment | string;
	patient?: string;
	caseStatusValue?: string;
	caseTypeIds?: string[];
	doctorId?: string[];
	workplaceId: string;
	created?: string;
}

interface Props {
	onFilter: (values: NurseCasesFilterFilterValues) => void;
}

const NurseCasesFilter: React.FC<Props> = ({ onFilter }) => {
	const { workplaceId } = useAppContext();
	const { handleSelectValue, checkEmptyString } = useFilters();
	const onFilterData = (values: any) => {
		const filter: NurseCasesFilterFilterValues = {
			createdAt: values?.createdAt
				? moment(values.createdAt).format('YYYY-MM-DD')
				: undefined,
			patient: checkEmptyString(values?.patient),
			caseStatusValue: values?.caseStatus?.value,
			caseTypeIds: values?.caseTypeIds?.length
				? values.caseTypeIds.map((item: SelectValue) => item.value)
				: undefined,
			doctorId: values?.doctorIds?.length
				? values.doctorIds.map((item: SelectValue) => item.value)
				: undefined,
			created: handleSelectValue(values?.createdStatus?.value),
			workplaceId,
		};
		onFilter(filter);
	};

	return (
		<GridFilter
			onChange={onFilterData}
			storageKey={GRID_FILTER_KEYS.NURSE_CASES_FILTER}>
			<GridFilterItem
				type={GridFilterItemType.CASE_TYPE}
				width={340}
				customPlaceholder='base.shared.pick'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.DOCTOR_IDS_NURSE_CASES_CUSTOM}
				width={320}
				customPlaceholder='base.startTypingSurname'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.CASE_STATUS}
				width={320}
				enableAutocomplete
				customPlaceholder='base.shared.pick'
			/>
			<GridFilterItem
				type={GridFilterItemType.CREATED_STATUS}
				width={220}
				enableAutocomplete
				customPlaceholder='base.shared.pick'
			/>
			<GridFilterItem
				type={GridFilterItemType.FULLTEXT}
				customKey='patient'
				customLabel='base.shared.patient'
				width={320}
				customPlaceholder='base.startTypingSurname'
				enableAutocomplete
			/>
		</GridFilter>
	);
};

export default NurseCasesFilter;
